/**
 * @file コンポーネント：フル動画ページ手術情報 スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル設定読み込み
import { mediaQuery } from "~/src/styles/mixins";

// スタイル
export const StyledButton = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 6px 10px 6px 8px;
    border: none;
    border-radius: 4px;
    background-color: #061c72;
    color: #ffffff;

    &.is-disabled {
        background-color: #d7d7d7;
        color: #868686;
        cursor: default;
    }
`;

export const StyledButtonIcon = styled.span`
    margin-right: 4px;
    width: 16px;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
`;

export const StyledButtonText = styled.span`
    font-size: 14px;
    line-height: 20px;
`;

export const StyledButtonlist = styled.ul`
    display: flex;
    flex-shrink: 0;
    justify-content: center;

    ${mediaQuery.sp(`
        flex-direction: column;
        align-items: center;
    `)};
`;

export const StyledButtonlistItem = styled.li`
    width: 319px;
    margin-right: 16px;

    &:last-of-type {
        margin-right: 0;
    }

    ${mediaQuery.sp(`
        margin-right: 0;
        margin-bottom: 8px;

        &:last-of-type {
            margin-bottom: 0;
        }
    `)};
`;

export const StyledContainer = styled.div`
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 8px 8px 12px;
`;

export const StyledContents = styled.div`
    display: flex;
    flex-grow: 1;
    margin-bottom: 10px;
    overflow-y: auto;
`;

export const StyledEdit = styled.p`
    text-align: right;
`;

export const StyledEditLink = styled.a`
    color: #eed393;
    font-size: 11px;
    line-height: 16px;

    &.is-disabled {
        opacity: #acadae;
        cursor: default;
        pointer-events: none;
    }
`;

export const StyledEditLinkIcon = styled.span`
    margin-right: 4px;
`;

export const StyledEditLinkText = styled.span``;

export const StyledEditText = styled.span`
    display: block;
    color: #eed393;
    margin-bottom: 8px;
`;

export const StyledSliderImage = styled.img`
    width: 100%;
    transition: filter 0.3s ease, opacity 0.3s ease;

    ${({ isLogin }) =>
        !isLogin &&
        `
        filter: blur(8px);
        opacity: 0.6;
        pointer-events: none;
    `}
`;

export const StyledSliderlist = styled.ul`
    flex: 2;
    margin-right: 16px;
`;

export const StyledSliderlistItem = styled.li`
    position: relative;
    margin-bottom: 16px;

    &:last-of-type {
        margin-bottom: 0;
    }
`;

export const StyledText = styled.div`
    flex: 3;
`;

export const StyledTextParagraph = styled.p`
    color: #ffffff;
    font-size: 12px;
    line-height: 14px;

    ${mediaQuery.pc(`
        font-size: 14px;
        line-height: 20px;
    `)};
 
    ${mediaQuery.pcWide(`
        font-size: 14px;
        line-height: 20px;
    `)};
`;
